export default __webpack_public_path__ + "static/media/element_58.3c25d7bc.jpg";